import { SearchTemplateMetadata } from '@/apis/searchtemplates';
import { getPlaceholderFiltersInLeafNode } from '@/util/searchTree/placeholderFilters';

export { getPlaceholderFiltersInLeafNode };

export {
  createSearchTemplateJson,
} from './searchTemplateSerialize';
export {
  findPlaceholdersInSearchTree,
  getHiddenPlaceholderKeys,
  getPlaceholderKeysInPositionOrder,
  placeholderFieldHash,
  updatePlaceholdersInSearchTreeInPlace,
} from './placeholderTree';

export const templateNameToDisplay = (
  templateMetadata: SearchTemplateMetadata | undefined,
  hasBeenModified: boolean
) => {
  return `${templateMetadata?.name || 'New Template'}${hasBeenModified ? '*' : ''}`;
};
